module.exports = __webpack_public_path__ + "static/offices-tile-image-555244e487622f90e820b79b4cb853ce.jpg";